import { ResponseStatus } from '@servicestack/client';
import BasicError from './BasicError';
import RequestError from './RequestError';
interface IErrorProps {
  responseStatus?: ResponseStatus;
  title?: string;
  description?: string;
}
const Error: React.FunctionComponent<IErrorProps> = ({
  responseStatus,
  title,
  description
}) => {
  if (responseStatus) {
    return <RequestError responseStatus={responseStatus} />;
  }
  return <BasicError title={title} description={description} data-sentry-element="BasicError" data-sentry-component="Error" data-sentry-source-file="Error.tsx" />;
};
export default Error;